<template>
  <div class="group-polls bg-push-black px-4 pt-2 md:pt-10 md:pr-10 md:pl-10">
    <!-- If you are the admin -->
    <div v-if="user.loggedIn">
      <UserInfo
        @countNumber="eventPollnumber = $event"
        class="mb-4 w-full bg-white text-center py-2"
        v-if="user.data.uid == groupData.user && Type == 'event'"
        :number="eventPollnumber"
        :user="user"
        :type="Type"
        :total="pollData.length"
        :status="groupData.event"
      />
    </div>
    <!-- If Group -->
    <Group
      v-if="groupData && $route.name == 'groupsingle'"
      :groupID="groupID"
      :groupData="groupData"
      :counter="counter"
    />
    <!-- If Event -->
    <Ev
      v-if="groupData && $route.name == 'eventsingle'"
      :groupID="groupID"
      :groupData="groupData"
      :counter="counterEvents"
    />

    <Poll
      :open="open"
      class="bg-white border border-push-lightgray shadow-lg"
      v-if="pollData[$route.params.pollId]"
      :poll="pollData[$route.params.pollId]"
      :gate="gateKeeperCookie(pollData[$route.params.pollId].name)"
      :type="Type"
      :group="groupData"
      :custom="custom"
      :last="groupLast"
      groupthanks="Thankyou, you have reached the end of this group of polls"
    />

    <!-- Event First Poll -->

    <Poll
      class="bg-white border border-push-lightgray shadow-lg"
      v-if="groupData.event == 'live' && Type == 'event'"
      :poll="pollData[eventPollnumber]"
      :gate="gateKeeperCookie(pollData[eventPollnumber].name)"
      :type="Type"
      :group="groupData"
      :custom="custom"
      :last="groupLast"
      :open="open"
      groupthanks="Thankyou, you have reached the end of this group of polls"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import UserInfo from "@/components/user/UserData.vue";
import Poll from "@/components/poll/Poll.vue";
import Group from "@/components/group/Group.vue";
import Ev from "@/components/group/Event.vue";
import firebase from "firebase/app";
import moment from "moment";
export default {
  name: "groupsingle",
  components: {
    Poll,
    Group,
    Ev,
    UserInfo
  },
  data() {
    return {
      open: true,
      eventPollnumber: 0,
      groupID: null,
      pollData: [],
      groupData: [],
      total: null,
      custom: {
        logo: require("@/assets/img/LogoPPmedium.png"),
        obgcolor: "#0066ff",
        otcolor: "#ffffff",
        ebgcolor: "#3c3c3b",
        etcolor: "#ffffff"
      }
    };
  },
  mounted() {
    this.fetchGroupData();
    this.getPollData();
    this.updateViews();
  },
  computed: {
    ...mapState({
      user: "user"
    }),
    Type() {
      var type = null;
      if (this.$route.name == "groupsingle") {
        type = "group";
      }
      if (this.$route.name == "eventsingle") {
        type = "event";
      }
      return type;
    },
    groupLast() {
      var result = false;
      //console.log(this.pollData.length, Number(this.$route.params.pollId) + 1);
      if (this.pollData.length == Number(this.$route.params.pollId) + 1) {
        result = true;
      }
      return result;
    },
    counter() {
      return Number(this.$route.params.pollId + 1) + "/" + this.pollData.length;
    },
    counterEvents() {
      return Number(this.eventPollnumber + 1) + "/" + this.pollData.length;
    }
  },
  methods: {
    currentDate() {
      var today = moment().format("YYYY-MM-DD:HH:mm");
      return today;
    },
    gateKeeperCookie(id) {
      var result = false;
      //console.log("vote" + id, this.$cookies.get("vote" + id));
      //Update Data
      if (this.$cookies.get("vote" + id)) {
        if (this.$cookies.get("vote" + id).poll == id) {
          result = true;
        }
      }
      return result;
    },
    dateKeeper(start, end) {
      console.log(start, end, this.currentDate());
      //Update Data
      if (this.currentDate() < start) {
        this.open = false;
      }
      if (end < this.currentDate()) {
        this.open = false;
      }
    },
    getPollData() {
      var vm = this;
      var firestore = firebase.firestore();
      firestore
        .collection("polls")
        .where("groupID", "==", Number(vm.$route.params.groupId))
        .onSnapshot(function(querySnapshot) {
          vm.pollData = [];
          querySnapshot.forEach(
            function(doc) {
              //console.log(doc.data());
              vm.pollData.push(doc.data());
              var startTime = doc.data().startDate + ":" + doc.data().startTime;
              var endTime = doc.data().endDate + ":" + doc.data().endTime;
              vm.dateKeeper(startTime, endTime);
            }.bind(vm)
          );
        });
    },
    updateViews() {
      var vm = this;
      var id = vm.$route.params.groupId;
      var firestore = firebase.firestore();
      var docRef = firestore.collection("groups").doc(String(id));
      docRef
        .update({
          visits: firebase.firestore.FieldValue.increment(1)
        })
        .then(function() {
          console.log("Document successfully updated view!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    fetchGroupData() {
      var vm = this;
      var id = vm.$route.params.groupId;
      var firestore = firebase.firestore();
      firestore
        .collection("groups")
        .doc(String(id))
        .onSnapshot(
          function(doc) {
            this.groupData = doc.data();
            this.groupID = doc.data().groupID;
            this.total = doc.data().total;
            this.eventPollnumber = doc.data().eventpoll;
          }.bind(vm)
        );
    }
  }
};
</script>
